import Route from 'cio/routes/base';
import CampaignModel from 'cio/models/campaign';
import Transition from '@ember/routing/transition';

export default class IndexRoute extends Route {
  afterModel(model: CampaignModel, _transition: Transition) {
    let route = model.isDraft ? 'setup' : 'overview';
    this.router.transitionTo(`campaigns.campaign.${route}`);
  }
}
